<template>
  <div class="filter-bar">
    <form
      role="form"
      class="form-inline"
    >
      <div class="input-group">
        <label class="sr-only">Search for:</label>
        <input
          v-model="filterText"
          type="text"
          class="form-control"
          placeholder="Search"
          @keyup.enter="doFilter"
        >
        <span class="input-group-btn">
          <button
            type="button"
            class="btn btn-primary"
            @click="doFilter"
          >Go!</button>
        </span>
      </div>
      <button
        class="btn btn-white m-l-md m-r-md"
        type="submit"
        @click="resetFilter"
      >Reset</button>
      <div class="checkbox">
        <input
          id="checkbox1"
          type="checkbox"
        >
        <label for="checkbox1">
          Remember me
        </label>
      </div>
    </form>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Filterbar",
  components: {},
  data() {
    return {
      filterText: ""
    };
  },
  methods: {
    doFilter() {
      this.$events.fire("filter-set", this.filterText);
    },
    resetFilter() {
      this.filterText = "";
      this.$events.fire("filter-reset");
    }
  }
};
</script>

<style scoped>
</style>
